import React from 'react';
import { Box, Typography } from '@mui/material';

function EmptyState({ title, message }) {
    return (
        <Box sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="h5" color="text.secondary" sx={{ mb: 2 }}>
                {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                {message}
            </Typography>
        </Box>
    );
}

export default EmptyState;

